import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from '@employee-configs/api.config';
import * as EmployeeModels from '@employee-models/index';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ManualActionsService {
    constructor(private httpClient: HttpClient) {}

    sendCCurePrehireData(): Observable<any | { error: HttpErrorResponse }> {

        return this.httpClient
            .post(
                ApiConfig.ManualActions.sendCCurePrehireData,
                null
            )
            .pipe(
                map(_ => ({})),
                catchError(error => of({ error })),
            );
    }

    sendCCureEmplyeeData(): Observable<any | { error: HttpErrorResponse }> {

        return this.httpClient
            .post(
                ApiConfig.ManualActions.sendCCureEmplyeeData,
                null
            )
            .pipe(
                map(_ => ({})),
                catchError(error => of({ error })),
            );
    }
}
